import React, {Component} from 'react';
import {Link, Redirect, withRouter} from 'react-router-dom';
import $ from "jquery";
import db from "../dbconn";
import fetch from "isomorphic-fetch";
import {API_ROOT, IMAGE_ROOT} from "../api-config";
import {withTranslation} from 'react-i18next';
import i18n from '../i18n';
class cardAdded extends Component{

    constructor(props, context) {
        super(props, context);

        this.state = {
            redirect: false,
            windowHeight: 0,
            nosessionredirect: false,
            categoryList: []
        };
    };

    componentWillMount() {

        if(!localStorage.getItem("store_language")){
            localStorage.setItem("store_language","en")
        }
        i18n.changeLanguage(localStorage.getItem("store_language")).then(r => {
        });
        var categroyUrl = '';

        var dbconn = new db();

        dbconn.getAll().then(data => {
            if (!data || data.length < 1 || sessionStorage.getItem('guestFlag') == 'Y') {
                this.setState({nosessionredirect: true});
            }
        });

    }

    componentDidMount() {

        document.title = "Add Card - " + localStorage.getItem("store_name") + " - Tria Commerce";
        window.addEventListener("newContentAvailable", () => {

            console.log("NEW CONTENT AVAILABLE");
        });

        var primaryColor = localStorage.getItem("store_primary_color");

        if (primaryColor != null) {
            document.documentElement.style.setProperty('--primaryColor', primaryColor);
        }
        var secondaryColor = localStorage.getItem("store_secondary_color");


        if (secondaryColor != null) {
            document.documentElement.style.setProperty('--secondaryColor', secondaryColor);
        }

        var lightColor = localStorage.getItem("store_light_color");

        if (lightColor != null) {
            document.documentElement.style.setProperty('--lightColor', lightColor);
        }
        var buttonColor = localStorage.getItem("store_button_color");

        if (buttonColor != null) {
            document.documentElement.style.setProperty('--buttonColor', buttonColor);
        }

        var height = $(window).height();
        this.setState({windowHeight: height});

        $('#submitBtn').click( e => {
            this.setState({redirect: true});
        });
    }

    render(){
        const {t} = this.props;
        if (this.state.nosessionredirect) {
            return (<Redirect to={'/'}/>);
        }

        if(this.state.redirect){
            return (<Redirect to={'/payment/methods'}/>);
        }

        return(
            <div className="mainContainer">

                <header>
                    <div className="col-md-12 col-sm-12 col-xs-12 previous-link">
                        <Link to={'/myaccount'}></Link>
                        <h2 className="text-center">{t('add_card')}</h2>
                    </div>
                </header>
                <div className="clearfix"></div>
                <div className="mt-white full-height" style={{top: "45px", position: "relative"}}>
                    <div className="simple-box m-b-0 p-b-35 p-0 bkg-white full-height m-grey">
                        <form name="" className="" method="post" encType="multipart/form-data" action="#">
                            <div className="form-box w-75 div-center">
                                <div className="header-title">
                                    <h2 className="text-center font-size-20 m-0">{t('card_added')}</h2>
                                </div>
                                <div className="header-content help_content">
                                    <p>{t('card_is_saved')}</p>
                                </div>

                                <div className="form-box">

                                    <div className="form-group">
                                        <input type="button" name="submitBtn" id="submitBtn" value={t('continue')} />
                                    </div>

                                </div>

                            </div>
                            <div className="clearfix"></div>

                        </form>
                    </div>
                </div>


                <div className="clearfix"></div>

            </div>
        );
    }
}

export default withRouter(withTranslation()(cardAdded));


// WEBPACK FOOTER //
// ./src/view_components/card_added.js